import { ItemAggregateTab, type ItemAggregateConfig } from '@/components/ItemAggregateTab'

const CONFIG: ItemAggregateConfig = {
  entityShort: '출고',
  entityDate: '출고일자',
  entityNo: '출고번호',
  partnerLabel: '거래처',
  partnerFilterPlaceholder: '전체 거래처',
  emptyDetailText: '이 품목의 출고 내역이 없습니다.',

  summaryApi: '/api/delivery/item-summary',
  summaryExportApi: '/api/delivery/item-summary/export',
  detailApi: '/api/sales-report',
  detailAcceptsSort: true,
  queryKeyPrefix: 'item-summary',
  excelFilePrefix: '출고현황_품목별',

  linkPath: '/main/delivery',
}

export function DeliveryByItemTab() {
  return <ItemAggregateTab config={CONFIG} />
}
